import { Box, Button, MenuItem, Select, Tooltip } from "@mui/material";
import ReleaseStageBadge from "app/components/ReleaseStageBadge";
import { BIBLIOGRAPHIC_PRIORITY_SUBTASKS, CUSTOM_FORMS_PRIORITY_SUBTASKS } from "app/utils/constants/intentPriorities";
import { useState } from "react";

const IntentSelectionComponent = ({ loading, disabledFields, handleModuleSubmit, intentList, setSwitchedComponent }) => {
  const [selectedValues, setSelectedValues] = useState({});
  const [hoveredTask, setHoveredTask] = useState(null);
  const [hoveredSubtask, setHoveredSubtask] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const TOOLTIP_STYLES = {
  tooltip: { sx: { backgroundColor: '#242428', color: '#fff' } },
  arrow: { sx: { color: '#242428' } }
};

    const safeJsonParse = (str) => {
    try { return JSON.parse(str); }
    catch (e) { return null; }
    };

  const getDisplayName = (category, description) => {
    if (category === "Custom Forms") {
      if (description === "Create New Custom Form") return "New";
      if (description === "Generate Custom Form") return "Existing";
    }
    return description;
  };

  const getSubmitValue = (category, description) => {
    if (category === "Custom Forms") {
      if (description === "New") return "Create New Custom Form";
      if (description === "Existing") return "Generate Custom Form";
    }
    return description;
  };

  const resetSelections = () => {
    const resetObj = {};
    Object.keys(intentList).forEach((key) => {
      resetObj[key] = "";
    });
    setSelectedValues(resetObj);
  };

  const handleDropdownChange = (category) => async (event) => {
    const rawValue = event.target.value;
    if (rawValue === "select") return;

    let selectedIntent;
    try {
      selectedIntent = JSON.parse(rawValue);
    } catch {
      return;
    }

    if (!selectedIntent.isActive) return;

    try {
      setSelectedValues((prev) => ({
        ...prev,
        [category]: rawValue
      }));

      setSwitchedComponent(false);
      await handleModuleSubmit({ textInput: getSubmitValue(category, selectedIntent.description) });

      resetSelections();
    } catch {
      resetSelections();
    }
  };

  const handleButtonClick = async (intentDescription) => {
    try {
      resetSelections();
      setSwitchedComponent(false);
      await handleModuleSubmit({ textInput: intentDescription });
    } catch {}
  };

  const renderDropdown = (category, intents) => {
    if (!Array.isArray(intents) || intents.length === 0) return null;

    let sortedIntents = intents.slice();
    if (category === "Bibliographic Data Extraction") {
      sortedIntents.sort((a, b) => {
        const aIndex = BIBLIOGRAPHIC_PRIORITY_SUBTASKS.indexOf(a.description);
        const bIndex = BIBLIOGRAPHIC_PRIORITY_SUBTASKS.indexOf(b.description);

        const aIsPriority = aIndex !== -1;
        const bIsPriority = bIndex !== -1;

        // Both are priority items → preserve defined order
        if (aIsPriority && bIsPriority) {
          return aIndex - bIndex;
        }

        // Only one is priority → priority comes first
        if (aIsPriority) return -1;
        if (bIsPriority) return 1;

        // Non-priority items → alphabetical
        return a.description.localeCompare(b.description);
      });
    } else if (category === "Custom Forms") {
      sortedIntents.sort((a, b) => {
        const aIndex = CUSTOM_FORMS_PRIORITY_SUBTASKS.indexOf(a.description);
        const bIndex = CUSTOM_FORMS_PRIORITY_SUBTASKS.indexOf(b.description);

        const aIsPriority = aIndex !== -1;
        const bIsPriority = bIndex !== -1;

        if (aIsPriority && bIsPriority) {
          return aIndex - bIndex;
        }

        if (aIsPriority) return -1;
        if (bIsPriority) return 1;

        return a.description.localeCompare(b.description);
      });
    } else {
      sortedIntents.sort((a, b) => a.description.localeCompare(b.description));
    }

    return (
      <Tooltip
        title={
          !(loading || disabledFields.dropdown)
            ? intents.find((i) => i.uiMeta?.task_hover)?.uiMeta?.task_hover || ""
            : ""
        }
      slotProps={TOOLTIP_STYLES}
        placement="right"
        arrow
        open={hoveredTask === category && !hoveredSubtask && !(loading || disabledFields.dropdown)}
      >
        <Box
          onMouseMove={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const isInside =
              e.clientX >= rect.left &&
              e.clientX <= rect.right &&
              e.clientY >= rect.top &&
              e.clientY <= rect.bottom;
            if (isInside) {
              setHoveredTask(category);
            } else {
              setHoveredTask((prev) => (prev === category ? null : prev));
            }
          }}
          onMouseLeave={() => {
            setHoveredTask((prev) => (prev === category ? null : prev));
          }}
        > 
      <Select
        open={openDropdown === category}
        onOpen={() => {
          setOpenDropdown(category);
        }}
        onClose={() => {
          setOpenDropdown(null);
          setHoveredSubtask(null);
        }}
        key={category}
        disabled={loading || disabledFields.dropdown}
        value={selectedValues[category] || ""}
        MenuProps={{
          PaperProps: {
            sx: { width: 0 },
          },
        }}
        sx={{
          fontSize: "0.7rem",
          marginBottom: ".5rem",
          width: "100%",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid lightgrey",
          },
        }}
        onChange={handleDropdownChange(category)}
        displayEmpty
        renderValue={(selected) => {
          const parsed = safeJsonParse(selected);
          return !parsed ? (
             <span style={{ fontSize: "0.8rem", color: "black" }}>{category}</span>
          ) : (
            getDisplayName(category, parsed.description)
          );
        }}
      >
        {sortedIntents.map((intent, index) => [
          <MenuItem
            value={JSON.stringify(intent)}
            key={intent.intentId}
            disabled={!intent.isActive}
                sx={{
                pointerEvents: "auto", 
                padding:0,
                "&.Mui-disabled": {
                  pointerEvents: "auto", 
                  opacity: 0.5,
                },

              "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.2)",
                },

                  "&.Mui-selected": {
                    backgroundColor: "rgba(0,0,0,0.08)",
                  },

                  "&.Mui-focusVisible": {
                    backgroundColor: "rgba(0,0,0,0.08)",
                  },
                                whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: "1.2rem",
                            display: "block",
                            maxWidth:'100%',
                }}
                        >
                          <Tooltip
                title={intent.uiMeta?.subtask_hover || ""}
                placement="right"
                arrow
                open={hoveredSubtask === intent.intentId}
                slotProps={TOOLTIP_STYLES}
              >
              <span style={{ display:"block", width: "100%", padding:'6px 16px', pointerEvents: "auto"}}
                onMouseEnter={() => setHoveredSubtask(intent.intentId)}
                onMouseLeave={() => setHoveredSubtask(null)}>
                <ReleaseStageBadge stage={intent.releaseStage} />
                {getDisplayName(category, intent.description)}
              </span>
            </Tooltip>
          </MenuItem>,
          index !== sortedIntents.length - 1 && (
            <div
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.1)",
                width: "100%",
                height: "1px",
              }}
            />
          ),
        ])}
      </Select>
      </Box>
      </Tooltip>
    );
  };

  const renderButton = (category, intent) => {
    if (!intent || Array.isArray(intent)) return null;

    return (
      <Box key={category} sx={{ display: "flex", flexDirection: "column", gap: "0.5rem", mb: "0.5rem" }}>
        <Tooltip key={`${intent.description}-tooltip`} placement="right"
        title={!(loading || disabledFields.dropdown) ? (intent?.uiMeta?.task_hover ?? '') : ""}
          arrow
        slotProps={TOOLTIP_STYLES}>
          <span
            style={{
              display: "block",
              cursor: !intent.isActive ? "not-allowed" : "pointer",
            }}
          >
            <Button
              fullWidth
              disabled={loading || disabledFields.dropdown}
              onClick={() => {
                if (intent.isActive === false) return;
                handleButtonClick(intent.description);
              }}
              sx={{
                justifyContent: "flex-start",
                textTransform: "none",
                letterSpacing: "0.2px",
                fontSize: "0.8rem",
                padding: ".7rem 1rem",
                color: intent.isActive === false ? "grey" : "black",
                "&.Mui-disabled": {
                  color: "#A2B2C3",
                },
                bgcolor: intent.isActive === false ? "lightgrey" : "transparent",
                textAlign: "left",
                border: "1px solid lightgrey",
                pointerEvents: intent.isActive === false ? "none" : "auto",
                ":hover": {
                  backgroundColor: intent.isActive === false ? "lightgrey" : "transparent",
                  borderColor: intent.isActive === false ? "lightgrey" : "black",
                },
              }}
            >
              <span style={{ whiteSpace: "wrap", maxWidth: "300px" }}>
                <ReleaseStageBadge stage={intent.releaseStage} />
                {intent.description}
              </span>
            </Button>
          </span>
        </Tooltip>
      </Box>
    );
  };

  const dropdownItems = Object.entries(intentList).filter(([_, value]) => Array.isArray(value));
  const buttonItems = Object.entries(intentList).filter(([_, value]) => !Array.isArray(value));

  return (
    <div>
      {dropdownItems.map(([category, value]) => renderDropdown(category, value))}
      {buttonItems.map(([category, value]) => renderButton(category, value))}
    </div>
  );
};

export default IntentSelectionComponent;